import React from "react";
import css from "./App.module.css";
import {Route,Routes,HashRouter} from "react-router-dom";
import {HomeScreen,GetStartedScreen,LibraryScreen,NotFoundScreen} from "Screens";


export default function App(){
    return (
        <div className={css.app}>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<HomeScreen/>}/>
                    <Route path="/getstarted" element={<GetStartedScreen/>}/>
                    <Route path="/:libname" element={<LibraryScreen/>}/>
                    <Route path="*" element={<NotFoundScreen/>}/>
                </Routes>
            </HashRouter>
        </div>
    );
}
